<template>
  <base-campaign-targeting-rule>
    <div>The popup will appear to {{ data }} visitors</div>
  </base-campaign-targeting-rule>
</template>

<script>
import BaseCampaignTargetingRule from "@/components/campaign-targeting-rules/BaseCampaignTargetingRule"
import targetingRuleMixin from "@/mixins/targeting-rule-mixin"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"

const mixin = targetingRuleMixin("who", targetingRuleNames.whoRules.returningOrNew)

export default {
  name: "TargetingReturningOrNew",
  components: { BaseCampaignTargetingRule },
  mixins: [mixin]
}
</script>
